import {Store} from 'redux';
import {createSteps} from '~/CreateFabricInvitation/navigation/createSteps';

export type DirectionParam = 'previous' | 'next';

export interface EventStep {
  name: string;
  id: number;
  nextRoute?: string | ((store: Store) => string) | null;
  previousRoute?: string | ((store: Store) => string) | null;
  displayName: string;
  showMegaNav?: boolean;
  meta?: {editing?: boolean};
  title?: string;
  saveOnLeave?: boolean;
  nextButtonText?: string | ((store: Store) => string);
  hideInWebView?: boolean;
  hideBottomNav?: boolean;
  previewButtons?: boolean;
  showSimpleNav?: boolean;
  showFooter?: boolean;
  preLeaveRouteFunction?:
    | ((store: Store, routeName: string, canvas: unknown) => unknown)
    | undefined;
  isUpsellMode?: (store: Store) => boolean;
}

// biome-ignore lint/correctness/noUnusedVariables: Intentionally excluding meta since meta is not a step
const {meta, ...stepsWithoutMeta} = createSteps;

export type StepConfig = typeof stepsWithoutMeta;
export type StepKey = keyof StepConfig;

export type StepOrDirection = StepKey | DirectionParam;

export const STEP_NAMES: StepKey[] = [
  'customize',
  'details',
  'gifting',
  'preview',
  'guests',
  'review',
  'send',
  'confirm',
  'exit',
];

export const validSteps: (StepKey | 'previous' | 'next')[] = [...STEP_NAMES, 'previous', 'next'];
